







































import { Component, Watch, Vue } from "vue-property-decorator";
import { ProviderFilter2 } from "@/store/modules/types";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import Pager from "@/components/Pager.vue";
import ProviderSearch from "@/components/provider/ProviderSearch.vue";
import ProviderList from "@/components/provider/ProviderList.vue";
import ProviderLog from "@/components/provider/ProviderLog.vue";
import ProviderEditor from "@/components/provider/ProviderEditor.vue";

@Component({
  components: {
    Header,
    EntityTabs,
    Pager,
    ProviderSearch,
    ProviderList,
    ProviderLog,
    ProviderEditor,
  }
})
export default class Provider extends Vue {
  filter = this.defaultFilter();
  pageRows: Array<any> = [];
  totalRows: number = 0;
  selected: any | null = null;

  @Watch("filter", { deep: true })
  onFilterChanged() {
    this.getProviders();
  }
  async getProviders() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("providers/getList", this.filter);
      this.totalRows = data.totalRows;
      this.pageRows = data.pageRows;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  defaultFilter(): ProviderFilter2 {
    return {
      name: "",
      npi: "",
      specialtyId: "",
      pageNumber: 1,
      rowsPerPage: 25,
    };
  }
  clearFilter() {
    this.filter = this.defaultFilter();
    this.getProviders();
  }
  editProvider(provider) {
    if (!this.entitySelected()) return;
    this.selected = provider;
    this.$modal.show("provider-editor");
  }
  showLog(provider) {
    if (!this.entitySelected()) return;
    this.selected = provider;
    this.$modal.show("provider-log");
  }
  entitySelected(): boolean {
    if (this.$store.state.auth.entityId == 0) {
      this.$modal.show("dialog", {
        title: "PatientCare",
        text:
          "Please select an <span class='wm-fw-500'>area or division</span>.",
      });
      return false;
    }
    return true;
  }
  rowsPerPageChanged(rowsPerPage: number) {
    this.filter.rowsPerPage = rowsPerPage;
    this.getProviders();
  }
  pageChanged(page: number) {
    this.filter.pageNumber = page;
    this.getProviders();
  }
  mounted() {
    this.getProviders();
  }
}
